import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { TokenValidation } from "../Utils/authValidationUtils";
import AddCompany from "../Pages/AddCompany";
import Companies from "../Pages/Companies";
import CompletedUsers from "../Pages/CompletedUsers";
import Letter from "../Pages/Letter";
import Login from "../Pages/Login";
import RequestedCompanies from "../Pages/RequestedCompanies";
import Services from "../Pages/Services";
import Home from "../Pages/Home";
import UserDetails from "../Pages/UserDetails";
import PrivateRoute from "./private";
import ContactUs from "../Pages/ContactUs";
import Locations from "../Pages/Locations";
import GuestDetails from "../Pages/GuestDetails";
import Settings from "../Pages/Settings";
import AdminManagement from "../Pages/AdminManagement";

const AppRoutes = () => {
  useEffect(() => {
    TokenValidation();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<PrivateRoute />}>
          <Route path="/home" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/service/:name" element={<Companies />} />
          <Route path="/service" element={<Companies />} />
          <Route path="/addCompany" element={<AddCompany />} />
          <Route path="/users" element={<CompletedUsers />} />
          <Route path="/user-details/:id" element={<UserDetails />} />
          <Route path="/guest-details/:id" element={<GuestDetails />} />
          <Route path="/req-org" element={<RequestedCompanies />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/letter" element={<Letter />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/admins" element={<AdminManagement />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
